/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsIdleAwsAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsIdleAwsAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsIdleAwsAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsIdleAwsAdvisorResource>): RecommendationForFinopsIdleAwsAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsIdleAwsAdvisorResource(), model);
        RecommendationForFinopsIdleAwsAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsIdleAwsAdvisorResource>): RecommendationForFinopsIdleAwsAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsIdleAwsAdvisorResource.newInstance(<RecommendationForFinopsIdleAwsAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsIdleAwsAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsIdleAwsAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsIdleAwsAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsIdleAwsAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
